(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dpr-klaviyo]');
    if (!button) return;

    var formId = button.getAttribute('data-dpr-klaviyo');
    if (!formId) return;

    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
})();
